// CloudAnimation.js
// This cloud animation was created by Mark Bowley
// https://codepen.io/Mark_Bowley/pen/LYZEBq

function CloudAnimation() {
    return (
        <>
            <div id="background-wrap">
                <div className="x1">
                    <div className="cloud"></div>
                </div>

                <div className="x2">
                    <div className="cloud"></div>
                </div>

                <div className="x3">
                    <div className="cloud"></div>
                </div>

                <div className="x4">
                    <div className="cloud"></div>
                </div>

                <div className="x5">
                    <div className="cloud"></div>
                </div>
            </div>
  
        </>
    )
}
export default CloudAnimation